import { authorizedInstance } from "../config/axios"

export const getIllustrationMappingsData = async ({
  endpoint,
  page,
  limit,
  sortBy,
  filters,
}) => {
  const query = new URLSearchParams({
    page,
    pageSize: limit,
    ...(sortBy ? { order: sortBy } : {}),
    ...(filters[0]?.value ? { filter: filters[0]?.value } : {}),
  })

  const response = await authorizedInstance.get(`/${endpoint}?${query}`)
  return response.data
}

export const getIllustrationMappingInfo = async ({ endpoint, mappingId }) => {
  const response = await authorizedInstance.get(`/${endpoint}/${mappingId}`)
  return response.data
}

export const createIllustrationMapping = async ({ endpoint, payload }) => {
  await authorizedInstance.post(`/${endpoint}`, payload)
}

export const updateIllustrationMapping = async ({ endpoint, payload }) => {
  const { illustrationMappingId: mappingId, ...body } = payload

  await authorizedInstance.put(`/${endpoint}/${mappingId}`, body)
}

export const deleteIllustrationMapping = async ({ endpoint, mappingId }) => {
  await authorizedInstance.delete(`/${endpoint}/${mappingId}`)
}
